export const createDeliveryDateApi = (fetchApi) => {
  function getDeliveryTimes(data) {
    return fetchApi(`/DeliveryTimes`, "POST", data);
  }

  return {
    getDeliveryTimes,
  };
};
